import produce from 'immer'
import { assign, set } from 'lodash'

import { METADATA_TYPES } from '../../../common/constants'
import { buildTreeHierarchy } from '../../../common/helpers'

import {
  ADD_FOOD_MOOD,
  DELETE_FOOD_MOOD,
  FETCH_FOOD_MOODS,
  RENAME_FOOD_MOOD,
  RESET_FOOD_MOOD_TREE,
  SAVE_FOOD_MOODS,
  SET_DATA_FOR_RENAMING_FOOD_MOOD,
} from '../action-types'
import { FOOD_MOODS_INITIAL_STATE } from '../initial-states'

const foodMoodsReducer = (state = FOOD_MOODS_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_FOOD_MOODS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          initialData: [],
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_FOOD_MOODS.COMPLETE:
      return produce(state, nextState => {
        const { results, latestEvent } = action.payload.data.foodMoods
        const treeData = buildTreeHierarchy(results, METADATA_TYPES.FOOD_MOODS)

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          initialData: treeData,
          data: treeData,
          latestEvent,
        })
      })

    case FETCH_FOOD_MOODS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
          initialData: [],
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_FOOD_MOODS.CLEANUP:
      return { ...FOOD_MOODS_INITIAL_STATE }

    case SAVE_FOOD_MOODS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          latestEvent: undefined,
        }),
      )

    case SAVE_FOOD_MOODS.COMPLETE:
      return produce(state, nextState => {
        const { results, latestEvent } = action.payload.data.saveFoodMoods

        const treeData = buildTreeHierarchy(results, METADATA_TYPES.FOOD_MOODS)

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          initialData: treeData,
          data: treeData,
          isDirty: false,
          dataForRenaming: undefined,
          latestEvent,
        })
      })

    case SAVE_FOOD_MOODS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
          latestEvent: undefined,
        }),
      )

    case DELETE_FOOD_MOOD.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
        }),
      )

    case DELETE_FOOD_MOOD.COMPLETE:
      return produce(state, nextState => {
        const { results } = action.payload.data.deleteFoodMood

        const treeData = buildTreeHierarchy(results, METADATA_TYPES.FOOD_MOODS)

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          initialData: treeData,
          data: treeData,
          isDirty: false,
          dataForRenaming: undefined,
        })
      })

    case DELETE_FOOD_MOOD.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
        }),
      )

    case ADD_FOOD_MOOD:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          data: [...nextState.data, action.payload],
          isDirty: true,
          dataForRenaming: { id: action.payload.id },
        }),
      )

    case RENAME_FOOD_MOOD:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          data: set(
            nextState.data,
            `${action.payload.path}.name`,
            action.payload.name,
          ),
          isDirty: true,
        }),
      )

    case SET_DATA_FOR_RENAMING_FOOD_MOOD:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          dataForRenaming: action.payload,
        }),
      )

    case RESET_FOOD_MOOD_TREE:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          data: nextState.initialData,
          isDirty: false,
          dataForRenaming: undefined,
        }),
      )

    default:
      return state
  }
}

export default foodMoodsReducer
